export default {
  app: {
    name: '北京中驰律师事务所',
    lang: 'zh',
    title: '北京中驰律师事务所'
  },

  nav: {
    home: '中驰首页',
    home_en: 'HOME',
    about: '关于中驰',
    about_en: 'ABOUT US',
    service: '业务领域',
    service_en: 'SERVICE',
    team: '律师团队',
    team_en: 'TEAM',
    activity: '中驰动态',
    activity_en: 'ACTIVITY',
    invite: '招贤纳士',
    invite_en: 'INVITE',
    contact: '联系我们',
    contact_en: 'CONTACT'
  },

  sections: {
    services: '业务范围',
    team: '律师团队',
    introduction: '律所介绍',
    news: '新闻动态'
  },

  messages: {
    hello: '欢迎访问北京中驰律师事务所',
    details: '查看详情',
    more: '查看更多',
    more_lawyers: '更多律师',
    more_introduction: '更多介绍',
    page_location: '当前位置：',
    contact_form: {
      title: '留言预约法律咨询/案件代理',
      name: '姓名',
      name_ph: '请输入姓名',
      mobile: '电话',
      mobile_ph: '请输入电话',
      address: '地域',
      address_ph: '请输入地域',
      content: '案情描述',
      content_ph: '请简单陈述案情',
      submit: '提交'
    }
  },

  breadcrumb: {
    home: '首页',
    about: '关于中驰',
    service: '业务领域',
    team: '律师团队',
    activity: '中驰动态',
    invite: '招贤纳士',
    contact: '联系我们'
  },

  about: {
    name: '关于中驰',
    home_content: `
      <p>
        北京中驰律师事务所系是位于北京市核心区东城区崇文门的一家综合性律师事务所，旨在为全国各地区、各行业、各领域提供优质的法律服务，涉及领域有刑事案件、婚姻家事、债权债务、合同纠纷、房产纠纷、股份纠纷、非诉服务、企业法律顾问服务等。
      </p>

      <p>
        律所总部位于北京市核心功能区东城区崇文门新世界中心写字楼B座11层，毗邻北京站，地铁2号线、5号线崇文门地铁站，交通极其便利。律所办公环境优美，办公面积近300平米。
      </p>
    `,
    content: `
      <p>
        北京中驰律师事务所系是位于北京市核心区东城区崇文门的一家综合性律师事务所，旨在为全国各地区、各行业、各领域提供优质的法律服务，涉及领域有刑事案件、婚姻家事、债权债务、合同纠纷、房产纠纷、股份纠纷、非诉服务、企业法律顾问服务等。
      </p>

      <p>
        律所总部位于北京市核心功能区东城区崇文门新世界中心写字楼B座11层，毗邻北京站，地铁2号线、5号线崇文门地铁站，交通极其便利。律所办公环境优美，办公面积近300平米。
      </p>

      <p>
        北京中驰律师事务所由赵自勇律师牵头组建创立，办所宗旨是为了更好地服务社会，帮助更多的人享有优质便捷的法律服务。律所以“服务百姓生活，维护社会公平正义”为执业理念，以“做一个对社会和对人民有益的律师”为所训，全心全意为委托人的合法权益服务。律所坚持社会公益事业，成立中驰律师多元调解室
        ——
        中驰律师事务所民间纠纷化解中心，积极参与我国多元化解决纠纷化解机制，构建社会主义和谐社会建设。中驰律师团队维护公平，伸张正义，竭力办案，用心对待每个当事人，拥有良好的信誉和口碑。
      </p>

      <p>中驰律师，中外驰名，值得您的信赖！</p>
    `
  },
  service: {
    name: '业务领域',
    criminal_case: '刑事案件',
    criminal_case_en: 'CRIMINAL CASE',
    criminal_case_desc: '刑事会见、取保候审、庭审辩护、二审上诉、死刑复核等',
    contract_dispute: '合同纠纷',
    contract_dispute_en: 'CONTRACT DISPUTE',
    contract_dispute_desc: '工程合同纠纷、承包合同纠纷、房产合同纠纷等各类合同纠纷',
    family_affairs: '婚姻家事',
    family_affairs_en: 'MARRIAGE/FAMILY AFFAIRS',
    family_affairs_desc: '离婚财产分割、孩子抚养权争取、离婚协议、遗产继承、房产纠纷等',
    debt_dispute: '债务纠纷',
    debt_dispute_en: 'DEBT DISPUTE',
    debt_dispute_desc: '个人债务纠纷、企业债务纠纷、个人与企业债务纠纷等',
    intellectual_property: '知识产权',
    intellectual_property_en: 'INTELLECTUAL PROPERTY',
    intellectual_property_desc: '商标纠纷、专利纠纷、著作权纠纷等',
    enterprise_legal: '企业法律服务',
    enterprise_legal_en: 'ENTERPRISE LEGAL SERVICES',
    enterprise_legal_desc: '常年企业法律顾问、企业案件代理、合同审核/拟定等',
    non_litigation: '非诉业务',
    non_litigation_en: 'NON-LITIGATION SERVICES',
    non_litigation_desc: '签发律师函、代写诉状、代写合同/协议、合同/协议审核',
    other: '其他业务',
    other_en: 'OTHER SERVICES',
    other_desc: '法律咨询、律师见证、拆迁纠纷、劳动纠纷等'
  },
  activity: {
    name: '中驰动态',
    news: '新闻动态',
    legal: '法律知识',
    search: '输入标题搜索',
    publish_time: '发布时间',
    view_count: '浏览量'
  },
  invite: {
    name: '招贤纳士'
  },
  contact: {
    name: '联系我们',
    content: `
      <h4 class="color-primary with-left-primary-color-bar">联系方式</h4>
      <p>
        <span>电话：</span>
        <span>010-67665196</span>
      </p>
      <p>
        <span>手机：</span>
        <span>13910962198</span>
      </p>
      <p>
        <span>邮箱：</span>
        <span>13910962198@139.com</span>
      </p>
      <p>
        <span>地址：</span>
        <span>北京市东城区崇文门外大街3号新世界中心写字楼B座11层</span>
      </p>
      <p>
        <span>交通：</span>
        <span>北京地铁2/5号线崇文门站H西南门出</span>
      </p>
    `
  },

  footer: {
    quick: '快捷入口',
    contact: '联系我们',
    address: '北京市东城区崇文门外大街3号新世界中心写字楼B座11层',
    code: '扫码关注中驰公众号',
    copyright: 'Copyright ©北京中驰律师事务所 版权所有'
  }
}
